import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { CardType } from './card-type.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class CardTypeService extends AbstractEntityService {

    protected resourceUrl = 'api/card-types';
    private resourceSearchUrl = 'api/_search/card-types';
    protected resourceCountUrl = 'api/_search/count/card-types';
    private resourceSearchOnlineCatalogNoAuthUrl = 'api/no-auth/_search/online-catalog/card-types';
    private resourceQueryOnlineCatalogNoAuthUrl = 'api/no-auth/online-catalog/schools/schoolId/card-types';
    private resourceQueryOnlineCatalogUrl = 'api/online-catalog/schools/schoolId/student/studentId/card-types';

    constructor(protected http: HttpClient) { super(http); }

    create(cardType: CardType): Observable<CardType> {
        let copy: CardType = Object.assign({}, cardType);
        return this.http.post<CardType>(this.resourceUrl, copy).map((res: CardType) => {
            return res;
        });
    }

    update(cardType: CardType): Observable<CardType> {
        let copy: CardType = Object.assign({}, cardType);
        return this.http.put<CardType>(this.resourceUrl, copy).map((res: CardType) => {
            return res;
        });
    }

    find(id: number): Observable<CardType> {
        return this.http.get<CardType>(`${this.resourceUrl}/${id}`).map((res: CardType) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<CardType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<CardType[]>>(this.resourceUrl, options)
            ;
    }

    search(req?: any): Observable<HttpResponse<CardType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<CardType[]>>(this.resourceSearchUrl, options)
            ;
    }

    searchOnlineCatalogNoAuth(req?: any): Observable<HttpResponse<CardType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<CardType[]>>(this.resourceSearchOnlineCatalogNoAuthUrl, options)
            .map((res: HttpResponse<CardType[]>) => res)
            ;
    }

    queryOnlineCatalogNoAuth(schoolId: number, req?: any): Observable<HttpResponse<CardType[]>> {
        if (!schoolId) {
            return;
        }

        let options = this.createRequestOption(req);
        let url = this.resourceQueryOnlineCatalogNoAuthUrl.replace('schoolId', schoolId.toString());
        return this.http.get<HttpResponse<CardType[]>>(url, options);
    }

    queryOnlineCatalog(schoolId: number, studentId: number, req?: any): Observable<HttpResponse<CardType[]>> {
        if (!schoolId || !studentId) {
            return;
        }

        let options = this.createRequestOption(req);
        let url = this.resourceQueryOnlineCatalogUrl.replace('schoolId', schoolId.toString())
                                                    .replace('studentId', studentId.toString());
        return this.http.get<HttpResponse<CardType[]>>(url, options);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card-type/card-type.service.ts